<h1 class="page-title mb-5">بنية أساسية حديثة ومتطورة</h1>
<div>
  <div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9 my-3">
        <p>بنية أساسية حديثة ومتطورة</p>
        <p>
          ​تمتلك مصر العديد من المزايا والمقومات في مجال البنية الأساسية، وقد
          حققت مصر إنجازات تاريخية وغير مسبوقة في مجال مشروعات البنية الأساسية
          حيث ستساهم هذه المشروعات في جعل مصر واحدة من أهم الدول على مستوى منطقة
          الشرق الأوسط وإفريقيا، وتعزز من دورها الإقليمي والدولي.
        </p>
        <div class="mt-5">
          <p>1.الطرق والنقل:</p>
          <img src="../../../../assets/development/eltr2.jpg" />
          <p>2. الكهرباء والطاقة:</p>
          <img src="../../../../assets/development/elctronics.jpg" />
          <p>3.البترول والغاز الطبيعي:</p>
          <img src="../../../../assets/development/betrol.jpg" />
        </div>
      </div>
      <div class="col-md-3">
        <app-fix-left-section></app-fix-left-section>
      </div>
    </div>
  </div>
</div>